import { MenuItem } from 'modules/layouts/LoggedLayout/components/Navbar/subcomponents/MenuItem';
import { FC, memo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useBasePathname } from 'shared/hooks/useBasePathname';
import { IconType } from 'shared/icons/SvgIcon';

export interface MenuPath {
  label: string;
  href: string;
  icon: IconType;
  activePaths?: string[];
  activeQueryParam?: string;
  count?: number;
}

interface MenuProps {
  paths: MenuPath[];
  onClose: () => void;
}

export const Menu: FC<MenuProps> = memo(({ paths, onClose }) => {
  const basePathname = useBasePathname();
  const [searchParams] = useSearchParams();

  return (
    <ul className="flex flex-col gap-1.5 border-t border-t-white/10 pt-8 lg:gap-4 lg:border-none lg:pt-0">
      {paths.map(({ label, href, icon, activePaths = [], activeQueryParam, count }) => {
        const isQueryParamMatching = activeQueryParam
          ? searchParams.get(activeQueryParam) === 'true'
          : false;
        return (
          <MenuItem
            onClick={onClose}
            key={href}
            label={label}
            href={href}
            icon={icon}
            count={count}
            active={
              isQueryParamMatching || basePathname === href || activePaths.includes(basePathname)
            }
          />
        );
      })}
    </ul>
  );
});
